/* eslint-disable */
// @ts-nocheck
import * as Types from '@xing-com/crate-common-graphql-types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type KununuQueryVariables = Types.Exact<{
  id: Types.Scalars['SlugOrID']['input'];
  reviewsLimit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;

export type KununuQuery = {
  __typename?: 'Query';
  company?: {
    __typename?: 'Company';
    id: string;
    companyName?: string | null;
    reviews?: {
      __typename?: 'CompanyKununuReviewConnection';
      total: number;
      edges: Array<{
        __typename?: 'CompanyKununuReviewEdge';
        node?: {
          __typename?: 'CompanyKununuReview';
          ratingAvg?: number | null;
          created?: string | null;
          title?: string | null;
          jobStatus?: Types.CompanyKununuReviewJobStatus | null;
          url?: string | null;
        } | null;
      } | null>;
    } | null;
    kununuData?: {
      __typename?: 'CompanyKununuData';
      profileUuid?: string | null;
      ratingCount?: number | null;
      ratingAverage?: number | null;
      employerRatingsCount?: number | null;
      companyProfileUrl?: string | null;
      kununuCommentsUrl?: string | null;
      evaluateProfileUrl?: string | null;
      recommendationRate?: number | null;
      benefits?: Array<{
        __typename?: 'CompanyMappedBenefit';
        type: Types.CompanyMappedBenefitType;
        approvals: number;
        percentage?: number | null;
      } | null> | null;
    } | null;
  } | null;
};

export const KununuDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Kununu' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SlugOrID' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'reviewsLimit' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'company' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'reviews' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'first' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'reviewsLimit' },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'node' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'ratingAvg' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'created' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'title' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'jobStatus' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'url' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'kununuData' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'profileUuid' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ratingCount' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ratingAverage' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'employerRatingsCount' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'companyProfileUrl' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'kununuCommentsUrl' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'evaluateProfileUrl' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'recommendationRate' },
                      },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'benefits' },
                        name: { kind: 'Name', value: 'mappedBenefits' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'approvals' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'percentage' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<KununuQuery, KununuQueryVariables>;
